import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';

import Feature from '../basic/feature';
import { ColumnFlex, ColumnFlexCentered } from '~/components/basic/containers';

const Container = styled(ColumnFlexCentered)`
  box-sizing: border-box;
  padding: 24px 24px 0;
  ${props => props.backgroundColor ? `background-color: ${props.backgroundColor};` : ``};
  width: 350px;
  border-radius: 8px;
  align-items: flex-start;
  height: 589px;
`;

const Title = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 24px;
  margin-bottom : 16px;
  color: ${({ theme }) => theme.lightFont};
  line-height: 32px;
  align-items: center;
`;

const Description = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.lightFont};
  font-weight: 600;
`;

const Header = styled.div`
  height: 100px;
`;

const FeaturesPanel = ({ featuresInfo }) => {
  const theme = useContext(ThemeContext);
  return (
    <Container fullWidth backgroundColor={featuresInfo.backgroundColor} >
      <ColumnFlex>
        <Header>
          <Title>
            {featuresInfo.title}
            {featuresInfo.Icon && <>&nbsp;<featuresInfo.Icon color={theme.star} /></>}
          </Title>
          <Description>{featuresInfo.description}</Description>
        </Header>
        {featuresInfo.features.map((feature, index) => (
          <Feature key={`feat-${index}`} boldText={feature.boldText} text={feature.text} fontSize={14} />
        ))}
      </ColumnFlex>
    </Container >
  );
}

FeaturesPanel.propTypes = {
  featuresInfo: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    backgroundColor: PropTypes.string,
    Icon: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
    ]),
    features: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      boldText: PropTypes.string,
    })),
  }),
}

export default FeaturesPanel;